<template>
    <Bar
        :options="chartOptions"
        :data="selectedDataBar"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
    />
</template>
<script>
    import { Bar } from 'vue-chartjs'
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        BarElement,
        CategoryScale,
        LinearScale
    } from 'chart.js'
    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
    export default {
        name: 'BarChart',
        components: { Bar },
        props: {
            budgetData: {
                type: Array
            },
            selectedDataBar: {
                type: Object
            },
            chartId: {
                type: String,
                default: 'bar-chart'
            },
            datasetIdKey: {
                type: String,
                default: 'label'
            },
            width: {
                type: Number
            },
            height: {
                type: Number
            },
            cssClasses: {
                default: '',
                type: String
            },
            styles: {
                type: Object,
                default: () => {}
            },
            plugins: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                chartData: {
                    datasets: [
                        {
                            barPercentage: 0,
                            barThickness: 1,
                            maxBarThickness: 15,
                            skipNull: true,
                            minBarLength: 1,
                            data: this.budgetData,
                            backgroundColor: ['#D7EB5A']
                        }
                    ]
                },
                chartOptions: {
                    responsive: false,
                    barThickness: this.getNewBarThickness,
                    barPercentage: 1,
                    indexAxis: 'x',
                    scales: {
                        x: {
                            display: false
                        },
                        y: {
                            display: false
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        }
                    }
                }
            }
        },
        computed: {
            // eslint-disable-next-line vue/return-in-computed-property
            getNewBarThickness() {
                if (this.selectedDataBar.labels.length <= 10) {
                    console.log(this.selectedDataBar.labels.length)
                    return 25
                }
            }
        }
    }
</script>
